import { QuickMenuService } from './quick-menu.service';
import { Component, OnInit, HostListener, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DashboardService } from '../../../pages/dashboard/dashboard.service';
import { takeUntil } from 'rxjs/operators';
import { RoutingService } from '../../..//services/routing/routing.service';

// Jquery
import * as $ from 'jquery';
import { Subject } from 'rxjs';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../sidenav-content';

@Component({
  selector: 'quick-menu',
  templateUrl: './quick-menu.component.html',
  styleUrls: ['./quick-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class QuickMenuComponent extends SidenavContent implements OnInit {
  quickLinkMenuItems: any;
  recentStaffPages: any;
  isClicking = false;
  isSaving: boolean;
  isSaved: boolean;

  private _unsubscribe$: Subject<void> = new Subject<void>();

  @HostListener('mousedown', ['$event']) onMouseDown(e) {
    this.isClicking = true;
  }

  @HostListener('mouseup', ['$event']) onMouseUp(e) {
    this.isClicking = false;
  }

  private _snackBar = inject(MatSnackBar);
  private _dashboardService = inject(DashboardService);
  private _quickMenuService = inject(QuickMenuService);
  private _routingService = inject(RoutingService);

  constructor(private _layoutService: LayoutService) {
    super(_layoutService);
  }

  ngOnInit() {
    this._quickMenuService.quickMenuItems$.pipe(takeUntil(this._unsubscribe$)).subscribe((data) => {
      if (data && !this.isClicking) {
        this.quickLinkMenuItems = data;
      }
    });

    this._dashboardService.staffHistory$.pipe(takeUntil(this._unsubscribe$)).subscribe((data) => {
      if (data) {
        this.recentStaffPages = data;
      }
    });
  }

  ngOnDestory() {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  drop(event: CdkDragDrop<string[]>, quickLinkMenuItems: any[]): void {
    moveItemInArray(quickLinkMenuItems, event.previousIndex, event.currentIndex);
    this._saveQuickMenu(quickLinkMenuItems);
  }

  moveQuickMenuItem(from: number, to: number): void {
    moveItemInArray(this.quickLinkMenuItems, from, to);
    this._saveQuickMenu(this.quickLinkMenuItems);
  }

  private _saveQuickMenu(items: any[]): void {
    this.isSaving = true;
    this.isSaved = false;
    this._quickMenuService.updateQuickMenu(items).subscribe({
      next: () => {
        this.isSaving = false;
        this.isSaved = true;
        setTimeout(() => {
          this.isSaved = false;
        }, 2000);
      },
      error: () => {
        this.isSaving = false;
        this._snackBar.open('Failed to update quick menu', null, { duration: 4000 });
      },
    });
  }

  deleteQuickMenuItem(item) {
    const body = [item];
    this._quickMenuService.deleteQuickMenu(body).subscribe({
      next: () => {
        this._snackBar.open('Quick menu item deleted', null, { duration: 4000 });
      },
      error: () => {
        this._snackBar.open('Failed to delete quick menu item', null, { duration: 4000 });
      },
    });
  }

  formatCtrlNumber(ordinal) {
    if (ordinal < 9) {
      return ordinal + 1;
    } else if (ordinal == 9) {
      return 0;
    }
  }

  loadQuickMenu(item) {
    this.closeNav();
    this._dashboardService.goToMenuItem(item.menuItem);
  }

  loadStaffHistory(item) {
    this.closeNav();
    this._dashboardService.goToMenuItem(item.menuItem);
  }

  loadStaffDashboard() {
    this.closeNav();
    this._routingService.goToDashboard();
  }

  closeOverlay() {
    $('#search-overlay').css('display', 'none');
  }
}
